export default __webpack_public_path__ + "static/media/fondo.088c14ad.png";